import { Grid, Stack, Typography } from '@mui/material';
import { DetailCard } from './DetailCard';

// The headline card at the top of a details page: a few figures side by side, each with a caption
// above and optional subtext below. Items are { key, label, value, subtext? }; a string subtext is
// set as a caption, anything else is rendered as given.
const SummaryStatCard = ({ items }) => (
  <DetailCard>
    <Grid container spacing={2}>
      {items.map(item => (
        <Grid item xs={12} md={12 / items.length} key={item.key}>
          <Stack spacing={1} sx={{ minWidth: 0 }}>
            <Typography variant="caption" color="#CFCFCF">
              {item.label}
            </Typography>
            <Typography variant="h6" sx={{ wordBreak: 'break-word' }}>
              {item.value == null || item.value === '' ? '--' : item.value}
            </Typography>
            {typeof item.subtext === 'string' ? (
              <Typography variant="caption" color="#CFCFCF" sx={{ wordBreak: 'break-word' }}>
                {item.subtext}
              </Typography>
            ) : (
              item.subtext ?? null
            )}
          </Stack>
        </Grid>
      ))}
    </Grid>
  </DetailCard>
);

export default SummaryStatCard;
